import { gql } from '@/core/shared/api';

export async function getContentOwnershipRating (_contentOwnership) {
  const query = `query contentOwnership ($contentOwnership: ContentOwnershipInput!) {
    contentOwnership(contentOwnership: $contentOwnership) {
      popularityOrder
      averageSessionDuration
      rating {
        count
        percentage
      }
    }
  }`;

  const { contentOwnership } = await gql.request(query, { contentOwnership: _contentOwnership });
  return contentOwnership;
}

export async function getContentOwnershipMonthlyMinutes (contentOwnership) {
  const query = `query contentOwnershipMinutes ($contentOwnership: ContentOwnershipInput!) {
    contentOwnershipMonthlyAnalytics(contentOwnership: $contentOwnership) {
      data
      labels
    }
  }`;

  const { contentOwnershipMonthlyAnalytics } = await gql.request(query, { contentOwnership });
  return contentOwnershipMonthlyAnalytics;
}

export async function getContentOwnershipAnalytics (contentOwnership, startTime, endTime) {
  const query = `query contentOwnershipAnalytics ($contentOwnership: ContentOwnershipInput!, $startTime: String, $endTime: String) {
    contentOwnershipAnalytics (contentOwnership: $contentOwnership, startTime: $startTime, endTime: $endTime) {
      geoCountriesWithMinutes {
        code
        value
      }
      geoNorthAmericaRegionsWithMinutes {
        code
        value
      }
    }
  }`;

  const { contentOwnershipAnalytics } = await gql.request(query, {
    contentOwnership,
    startTime,
    endTime,
  });
  return contentOwnershipAnalytics;
}

export async function contentOwnershipUsageAnalytics (contentOwnership, usage, startTime, endTime) {
  const query = `query contentOwnershipUsageAnalytics ($contentOwnership: ContentOwnershipInput!, $usage: ContentOwnershipAnalyticsUsageType!, $startTime: String, $endTime: String) {
    contentOwnershipUsageAnalytics (contentOwnership: $contentOwnership, usage: $usage, startTime: $startTime, endTime: $endTime) {
      enabled
      earnings
      minutes
      licenses
      stations
      locations
    }
  }`;

  const { contentOwnershipUsageAnalytics } = await gql.request(query, {
    contentOwnership,
    usage,
    startTime,
    endTime,
  });
  return contentOwnershipUsageAnalytics;
}

export async function requestContentOwnershipExport (contentOwnership, type, startTime, endTime) {
  const query = `mutation requestContentOwnershipAnalyticsExport ($contentOwnership: ContentOwnershipInput!, $type: String, $startTime: String, $endTime: String) {
    requestContentOwnershipAnalyticsExport (
      contentOwnership: $contentOwnership,
      type: $type,
      startTime: $startTime,
      endTime: $endTime
    )
  }`;

  const { requestContentOwnershipAnalyticsExport } = await gql.request(query, {
    contentOwnership,
    type,
    startTime,
    endTime,
  });
  return requestContentOwnershipAnalyticsExport;
}
